import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function FiltersReducer(state = initialState.filtersData, action: any) {
  switch (action.type) {
    case types.SAVE_FILTERSDATA_SUCCESS:
      return action.filtersData;
    default:
      return state;
  }
}
